import { motion } from "framer-motion";
import { ArrowRight, ArrowDown } from "lucide-react";
import { REGISTER_URL, ASSETS } from "@/lib/site";
import { scrollToSection } from "@/lib/scroll";

export const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative pt-36 pb-20 md:pt-44 md:pb-28 overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          <motion.div
            className="lg:col-span-6"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-1.5 text-xs font-semibold tracking-[0.18em] uppercase text-brand-blue">
              Built for UK subcontractors
            </span>

            <h1 className="mt-6 font-heading font-800 text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-brand-navy">
              Takeoff, estimating and{" "}
              <span className="text-brand-blue">getting paid</span> — all in one
              place
            </h1>

            <p className="mt-6 max-w-xl text-lg leading-relaxed text-slate-600">
              Blue Shuck is the simple platform built for UK subcontractors.
              Measure from your blueprints, build estimates in minutes, and send
              professional Applications for Payment your clients can pay in a
              click.
            </p>

            <div className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <a
                data-testid="hero-register-cta"
                href={REGISTER_URL}
                className="inline-flex items-center justify-center gap-2 bg-brand-navy text-white font-medium px-7 py-3.5 rounded-lg hover:bg-brand-navy-dark transition-colors text-base"
              >
                Start free — no card needed
                <ArrowRight className="h-5 w-5" strokeWidth={2} />
              </a>
              <button
                data-testid="hero-how-it-works-scroll"
                onClick={() => scrollToSection("features")}
                className="inline-flex items-center justify-center gap-2 bg-white text-slate-700 border border-slate-200 font-medium px-7 py-3.5 rounded-lg hover:bg-slate-50 hover:text-brand-navy transition-colors text-base"
              >
                See how it works
                <ArrowDown className="h-4 w-4" />
              </button>
            </div>
          </motion.div>

          <motion.div
            className="lg:col-span-6"
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="relative rounded-2xl overflow-hidden border border-slate-200 shadow-xl">
              <img
                src={ASSETS.heroBuilding}
                alt="Modern construction facade with blue glass"
                className="w-full h-[380px] md:h-[480px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-brand-navy/70 via-brand-navy/20 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5 flex items-center gap-4 rounded-xl bg-white/95 backdrop-blur-sm border border-white/60 px-5 py-4 shadow-lg">
                <img
                  src={ASSETS.wolfNavy}
                  alt=""
                  aria-hidden="true"
                  className="h-11 w-11 object-contain"
                />
                <div>
                  <p className="font-heading font-700 text-brand-navy leading-tight">
                    Takeoff · Estimating · Payments
                  </p>
                  <p className="text-sm text-slate-500">
                    One simple platform for subcontractors
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
